import { useContext, useEffect, useState } from 'react';
import { useLoadingState } from '../../hooks/useLoader';
import { AuthContext } from '../../contexts/AuthContext';
import StatsCardGreenpill from '../../ui/StatsCardGreenpill';

import { GreenpillLeaderboardTable } from './GreenpillLeaderboardTable';
import { formatNumber } from '../../helpers/formatNumber';
import TrophyIcon from '../../assets/icons/TrophyIcon';
import Table from '../../ui/TableGreenpill';
import NoDataAvailable from '../../ui/NoDataAvailable';
import Bg from '../../assets/bg.png';
import Loader from '../../ui/Loader';
import RankOneIcon from '../../assets/icons/RankOneIcon';
import RankTwoIcon from '../../assets/icons/RankTwoIcon';
import RankThreeIcon from '../../assets/icons/RankThreeIcon';
import AvatarImage from '../../ui/AvatarImage';
import { getEntryCount, getGreenpillLeaderboard } from '../../apis/geenpills/greenpillLeaderboard';
import LeaderboardFilter from './LeaderboardFilter';

const ranks = {
    1: <RankOneIcon />,
    2: <RankTwoIcon />,
    3: <RankThreeIcon />,
};

const GreenpillLeaderboard = () => {
    const { loading, startLoading, stopLoading } = useLoadingState();
    const { state: authState } = useContext(AuthContext);

    const {
        loading: gettingMyDetails,
        startLoading: startGettingMyDetails,
        stopLoading: stopGettingMyDetails,
    } = useLoadingState();
    const [myDetails, setMyDetails] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [selectedLandscapes, setSelectedLandscapes] = useState([]);

    const [leaderboardData, setLeaderboardData] = useState([]);

    const entriesHandler = (val) => {
        setEntriesPerPage(val);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                startGettingMyDetails();
                const response3 = await getGreenpillLeaderboard(
                    selectedLandscapes.length === 0 ? undefined : selectedLandscapes[0],
                    undefined,
                    currentPage,
                    entriesPerPage,
                    true
                );

                setMyDetails(response3?.data[0]);
            } catch (error) {
                console.error(error, 'error');
            } finally {
                stopGettingMyDetails();
            }
        };
        fetchData();
    }, [selectedLandscapes]);

    useEffect(
        function () {
            const fetchData = async () => {
                try {
                    startLoading();

                    if (selectedLandscapes.length === 0) {
                        const [response2, response3] = await Promise.all([
                            getGreenpillLeaderboard(undefined, undefined, currentPage, entriesPerPage, false),
                            getEntryCount(),
                        ]);

                        setLeaderboardData(response2?.data);
                        setTotalEntries(response3?.data);
                    } else {
                        const [response2, response3] = await Promise.all([
                            getGreenpillLeaderboard(
                                selectedLandscapes[0],
                                undefined,
                                currentPage,
                                entriesPerPage,
                                false
                            ),
                            getEntryCount(selectedLandscapes[0]),
                        ]);

                        setLeaderboardData(response2?.data);
                        setTotalEntries(response3?.data);
                    }
                } catch (error) {
                    console.error(error, 'error');
                } finally {
                    stopLoading();
                }
            };
            fetchData();
        },
        [selectedLandscapes, currentPage, entriesPerPage]
    );

    return (
        <div
            style={{
                // backgroundImage: `url(${Bg})`,
                backgroundColor: '#F1F5F3',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }}
            className="bg-fixed  p-9 min-h-screen "
        >
            <div className="   pb-9">
                <div className=" ">
                    <h1
                        className="text-5xl font-semibold text-tPrimary"
                        style={{
                            textShadow: '0px 0px 11.8px rgba(255, 255, 255, 0.59)',
                        }}
                    >
                        Greenpill Leaderboard
                    </h1>
                    <h6 className="text-sm text-tSecondary mt-1">
                        More of the network you use, more impact points you earn. IPs are used for all loyalty and
                        incentive programs within the network
                    </h6>
                </div>
                <div className=" flex items-center gap-3 my-5">
                    <StatsCardGreenpill label="Greenpills" stats={myDetails?.greenpills} loading={gettingMyDetails} />
                    <StatsCardGreenpill
                        label="IP unlocked till now"
                        symbol={<TrophyIcon />}
                        stats={myDetails?.totalImpactPoints ? Number(myDetails?.totalImpactPoints)?.toFixed(2) : 0}
                        loading={gettingMyDetails}
                    />
                    <StatsCardGreenpill
                        label="My Rank"
                        symbol={<p className="text-4xl font-medium ">#</p>}
                        stats={myDetails?.rank}
                        loading={gettingMyDetails}
                    />
                </div>

                <div className="flex items-center justify-between  mt-8 mb-4">
                    <LeaderboardFilter
                        selectedLandscapes={selectedLandscapes}
                        setSelectedLandscapes={setSelectedLandscapes}
                        onChangingLandscape={() => setCurrentPage(1)}
                    />
                    {totalEntries > 10 && (
                        <button
                            onClick={() => {
                                setCurrentPage(Math.ceil(myDetails?.rank / 10));
                            }}
                            // disabled={disabled}
                            className="flex items-center gap-2 text-[white]  justify-center  w-fit min-w-44 font-medium  bg-[#2C5E54] rounded-lg px-4 py-2 "
                            type="button"
                        >
                            <span>Go to my rank</span>
                        </button>
                    )}
                </div>

                <div>
                    <GreenpillLeaderboardTable
                        leaderboardData={[myDetails, ...leaderboardData]}
                        selectedLandscapes={selectedLandscapes}
                        myLeaderDetails={myDetails}
                        loading={loading}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalEntries={totalEntries}
                        entriesPerPage={entriesPerPage}
                        entriesHandler={entriesHandler}
                        color="fill-[#326F58]"
                    />
                </div>
            </div>
        </div>
    );
};

export default GreenpillLeaderboard;
